module.exports = __webpack_public_path__ + "img/car-front.9890b7a1.svg";